import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseInputComponent } from '../base-input/base-input.component';
import { DateRangeInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class DateRangePickerComponent extends BaseInputComponent implements OnInit {
    @Input() input: DateRangeInputType;
    private endDateSubscription: Subscription;

    constructor(private questionStateService: QuestionStateService) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
        this.endDateSubscription = this.input.endDateFormControl.valueChanges.subscribe((value) => {
            this.inputValueChangeEventEmitter.emit({
                payload: this.input.control.value,
                secondaryPayload: value,
                input: this.input
            });
        });
    }
}
